
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function AboutHero() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <section className="relative min-h-[60vh] md:min-h-[85vh] overflow-hidden">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:py-6 flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/2063d56d77349d69e524f0264c628611/11429a8bbabca3c2bd48cc699fa75d27.png"
                alt="Tadashi Consulting"
                className="h-10 lg:h-12 w-auto object-contain"
              />
            </Link>
          </div>
          <div className="hidden lg:flex items-center gap-8">
            <Link to="/about" className="text-sm font-medium text-[#D4AF37]">
              About
            </Link>
            <span className={`w-px h-4 ${scrolled ? 'bg-[#D4AF37]' : 'bg-white/40'}`}></span>
            <Link
              to="/residential-renovations"
              className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}
            >
              Residential
            </Link>
            <span className={`w-px h-4 ${scrolled ? 'bg-[#D4AF37]' : 'bg-white/40'}`}></span>
            <Link
              to="/commercial-construction"
              className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}
            >
              Commercial
            </Link>
            <span className={`w-px h-4 ${scrolled ? 'bg-[#D4AF37]' : 'bg-white/40'}`}></span>
            <a
              href="/#gallery"
              className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}
            >
              Gallery
            </a>
            <span className={`w-px h-4 ${scrolled ? 'bg-[#D4AF37]' : 'bg-white/40'}`}></span>
            <a
              href="/#contact"
              className="px-8 py-3 bg-[#D4AF37] text-white text-sm font-semibold rounded-full hover:bg-[#B8941F] transition-all shadow-md whitespace-nowrap"
            >
              Book Site Inspection
            </a>
          </div>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-800' : 'text-white'}`}
            ></i>
          </button>
        </div>
        {menuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 shadow-xl">
            <div className="px-6 py-6 space-y-4">
              <Link
                to="/about"
                onClick={() => setMenuOpen(false)}
                className="block text-base font-medium text-[#D4AF37] py-2"
              >
                About
              </Link>
              <Link
                to="/residential-renovations"
                onClick={() => setMenuOpen(false)}
                className="block text-base font-medium text-gray-700 hover:text-[#D4AF37] transition-colors py-2"
              >
                Residential
              </Link>
              <Link
                to="/commercial-construction"
                onClick={() => setMenuOpen(false)}
                className="block text-base font-medium text-gray-700 hover:text-[#D4AF37] transition-colors py-2"
              >
                Commercial
              </Link>
              <a
                href="/#gallery"
                onClick={() => setMenuOpen(false)}
                className="block text-base font-medium text-gray-700 hover:text-[#D4AF37] transition-colors py-2"
              >
                Gallery
              </a>
              <a
                href="/#contact"
                onClick={() => setMenuOpen(false)}
                className="block text-center px-8 py-3 bg-[#D4AF37] text-white text-sm font-semibold rounded-full hover:bg-[#B8941F] transition-all shadow-md whitespace-nowrap mt-4"
              >
                Book Site Inspection
              </a>
            </div>
          </div>
        )}
      </nav>

      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cf34e214e6dedff2042e55d6609674da.jpg"
          alt="Tadashi Consulting Team - Luxury Renovation Experts Johannesburg"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 md:pt-48 pb-16 md:pb-24 w-full flex flex-col items-center text-center">
        <p className="text-xs font-semibold tracking-[0.3em] text-[#D4AF37] uppercase mb-4 md:mb-6">
          Our Story
        </p>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6">
          About <span className="font-serif text-[#D4AF37]">Tadashi Consulting</span>
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white/85 leading-relaxed max-w-3xl px-2">
          A full-service <strong>renovation and construction</strong> partner in Johannesburg,
          delivering <strong>luxury transformations</strong> through expert craftsmanship,
          licensed contractors, and unwavering accountability.
        </p>
      </div>
    </section>
  );
}
